import { CantileverChair } from '../parts/seating'
import type { AssetContext, AssetDefinition } from '../types'

/**
 * Cantilever meeting chair — a thin wrapper over the shared `CantileverChair`
 * assembly (sled frame in metal, seat and back as one upholstery tone).
 *
 * Origin at the centre of the 0.54 x 0.58 footprint, y = 0 on the floor, the
 * sitter facing +Z. The upholstered variant switches the shell to the accent
 * tone rather than a per-instance colour, because the sub-assembly exposes a
 * tone and not a colour for its cushions.
 */
function ChairMeeting({ variant = 'negra' }: AssetContext) {
  const upholstered = variant === 'tapizada'

  return <CantileverChair tone={upholstered ? 'accent' : 'dark'} frameTone="metal" seatHeight={0.45} />
}

export const definition: AssetDefinition = {
  id: 'chair-meeting',
  name: 'Silla de reunión',
  category: 'seating',
  footprint: [0.54, 0.58],
  height: 0.88,
  seats: 1,
  occupantSide: 'front',
  seatInset: 0.29,
  variants: [
    { id: 'negra', name: 'Negra' },
    { id: 'tapizada', name: 'Tapizada' },
  ],
  keywords: [
    'silla',
    'reunión',
    'visita',
    'confidente',
    'patín',
    'sala de juntas',
    'meeting chair',
    'visitor chair',
    'cantilever chair',
    'conference',
  ],
  Component: ChairMeeting,
}
